import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import SettingLayer from "../components/SettingLayer";

const SettingsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Loyalty Program' />

        {/* BlogLayer */}
        <SettingLayer />
      </MasterLayout>
    </>
  );
};

export default SettingsPage;